import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getRelatedBlog } from "./relatedBlogAPI";

const initialState = {
  relatedBlogs: [],
  isLoading: false,
  isError: false,
  error: "",
};

export const fetchRelatedBlog = createAsyncThunk(
  "relatedBlogs/fetchRelatedBlog",
  async ({ id, tags }) => {
    const blog = await getRelatedBlog(id, tags);
    return blog;
  }
);

export const relatedBlogSlice = createSlice({
  name: "blog",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchRelatedBlog.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
        state.error = "";
      })
      .addCase(fetchRelatedBlog.fulfilled, (state, action) => {
        state.isLoading = false;
        state.relatedBlogs = action.payload;
      })
      .addCase(fetchRelatedBlog.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
        state.relatedBlogs = [];
      });
  },
});

export default relatedBlogSlice.reducer;
